<script>
  import api from '../api'

  export default {
    props: ['photo'],

    computed: {
      thumb () {
        return process.env.MIX_CDN + '500x0/' + this.photo.path
      },

      web () {
        return process.env.MIX_CDN + '2000x2000/' + this.photo.path
      },

      webName () {
        return 'WQ_' + this.photo.path
      },

      download () {
        return process.env.MIX_CDN + this.photo.path
      },

      downloadName () {
        return 'PQ_' + this.photo.path
      }
    },

    methods: {
      bin() {
        swal({
          title: "Are you sure?",
          showCancelButton: true,
          closeOnConfirm: false
        },
          async () => {
            await api.apios.delete(`/api/address_photos/${this.photo.id}`)
            swal.close()
            this.$emit('refresh')
          });
      }
    }
  }
</script>
<template>
  <div class="card">
    <header class="card-header">
      <p class="card-header-title address-card-title">
        {{ photo.path }}
      </p>
      <a class="card-header-icon" title="Download Web Version" :download="webName" :href="web">
        <i class="fa fa-laptop"></i>
      </a>
      <a class="card-header-icon" title="Download Print Version" :download="downloadName" :href="download">
        <i class="fa fa-download"></i>
      </a>
      <a class="card-header-icon" @click.stop="bin">
        <i class="fa fa-trash"></i>
      </a>
    </header>
    <div class="card-image">
      <figure class="image">
        <img :src="thumb" />
      </figure>
    </div>
  </div>
</template>
